import { request } from '@/utils/request'
export default {
    proList: (params, loading) => {
        return request('/api/web/product/list', params, loading)
    },
    proInfoDetail: (params, loading) => {
        return request('/api/web/product/detail', params, loading)
    },
}


// WEBPACK FOOTER //
// ./src/api/productManagement.js